import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  Checkbox,
  message,
} from "antd";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { UploadOutlined, StarOutlined } from "@ant-design/icons";
import config from "../../../config";
import { professionalAction } from "../../../_actions/professional.actions";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalService } from "../../../_services";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const PreventiveForm = forwardRef((props, ref) => {
  console.log("props", props);
  const baseUrl = config.apiGateway.baseUrl;
  const [form] = Form.useForm();
  const [progress, setProgress] = useState(0);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [tapshilsfile, Settapshilsfile] = useState([]);
  const [preventiveType, SetPreventiveType] = useState([]);
  const { t } = useContext(LanguageContext);
  const [selectDistricts, setSelectDistricts] = useState();
  const [preventive, setPreventive] = useState(
    props?.editPreventiveInformationData?.preventive_action,
  );
  const [EditPreventiveAction, setEditPreventiveAction] = useState();

  useEffect(() => {
    let user = props?.user;

    if ((user && user?.role === "2") || (user && user?.role === 2)) {
      professionalService.getDistrict(user?.cityId).then((res) => {
        setDistricts(res.pc_districts);
      });
    }
  }, [form]);

  const preventiveAction =
    parseInt(props?.editPreventiveInformationData[0]?.preventive_action, 10) ||
    null;

  const [selectedPreventiveType, setSelectedPreventiveType] = useState(
    preventiveAction || null,
  );

  useEffect(() => {
    setSelectedPreventiveType(preventiveAction || null);
  }, [props.editPreventiveInformationData]);
  console.log("select districts", selectDistricts);
  // const [preventiveType, SetPreventiveType] = useState([
  //   "सीआरपीसी कलम 107",
  //   "सीआरपीसी कलम 110",
  //   "सीआरपीसी कलम 144 (3)",
  //   "मपोका कलम 68/69",
  //   "मपोका कलम 55",
  //   "मपोका कलम 56",
  //   "मपोका कलम 57",
  //   "मंबई दारूबंदी कायदा कलम 93",
  //   "महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)",
  //   "सीआरपीसी कलम 109",
  //   "सीआरपीसी कलम 151",
  //   "एम पी डी ए सीआरपीसी कलम 151(3)"
  // ]);
  const [tadipar, seTadipar] = useState();
  const [tadiparType, SetTadiparType] = useState([
    "मपोका कलम 55",
    "मपोका कलम 56",
    "मपोका कलम 57",
  ]);
  const [tadiparShow, settadiparShow] = useState(false);
  const [inputField, setInputField] = useState({
    preventive_action: "",
    chaptorCase: "",
    chaptorCaseYear: "",
    date_issue_bond: "",
    date_from: "",
    date_to: "",
    tadipar_unit: "",
    orderType: "",
    orderFIle: "",
    action_taken_police_station: "",
    proposal_sent_date: "",
  });

  useEffect(() => {
    // if (props?.preventiveAction && props?.preventiveAction?.data.length > 0) {
    //   SetPreventiveType(props.preventiveAction.data);
    // }
    if (
      props.dataStates &&
      props.dataStates.pc_cities &&
      props.dataStates.pc_cities
    ) {
      setCities([...props.dataStates.pc_cities]);
    }
    form.resetFields();
    Settapshilsfile([]);
  }, [props.resetPreventiveForm]);

  const getDistrictName = () => {
    if (districts && districts.length) {
      const found = districts.find(
        (o) => String(o.id) === String(props.district),
      );
      if (found) {
        setSelectDistricts(found.DistrictName);
        form.setFieldsValue({
          action_taken_police_station: found.DistrictName,
        });
      }
    }
  };

  const [preventiveActionData, setPreventiveAction] = useState([]);

  const getPreventiveData = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };

  useEffect(() => {
    getPreventiveData();
  }, []);

  useEffect(() => {
    if (
      (props.role === "2" || props.role === 2) &&
      districts &&
      districts.length &&
      props.district
    ) {
      getDistrictName();
    }
  }, [props.role, districts, props.district]);

  useEffect(
    (res) => {
      if (
        props.editPreventiveInformationData &&
        props.editPreventiveInformationData.length
      ) {
        let ob = {
          ...props.editPreventiveInformationData[0],
        };
        delete ob.date_from;
        delete ob.date_to;
        // delete ob.date_issue_bond;

        if (
          ob.preventive_action === 5 ||
          ob.preventive_action === 6 ||
          ob.preventive_action === 7
        ) {
          settadiparShow(true);
        } else {
          settadiparShow(false);
        }

        const selectedType = ob.type || "final_bond";
        setBondType(selectedType);
        form.setFieldsValue({
          ...ob,
          type: selectedType,
          preventive_action: preventiveAction,
          date_from: moment(props.editPreventiveInformationData[0].date_from),
          date_to: moment(props.editPreventiveInformationData[0].date_to),
          date_issue_bond: moment(
            props.editPreventiveInformationData[0].date_issue_bond,
          ),
          chaptorCaseYear: props.editPreventiveInformationData[0]
            .chaptorCaseYear
            ? moment(props.editPreventiveInformationData[0].chaptorCaseYear)
            : "",
          tadipar_unit:
            props.editPreventiveInformationData[0].tadipar_unit &&
            props.editPreventiveInformationData[0].tadipar_unit.split(","),
          proposal_sent_date: props.editPreventiveInformationData[0]
            .proposal_sent_date
            ? moment(props.editPreventiveInformationData[0].proposal_sent_date)
            : "",
          action_taken_police_station:
            props.role === "4"
              ? props.editPreventiveInformationData[0]
                  .action_taken_police_station
              : props.role === "2" && getDistrictName(),
          orderType: props.editPreventiveInformationData[0].orderType
            ? props.editPreventiveInformationData[0].orderType
            : "",
        });
        if (props.role === "2") {
          getDistrictName();
        }
        const orderFileName = props.editPreventiveInformationData[0].orderFIle;
        Settapshilsfile(
          orderFileName
            ? [
                {
                  uid: "1",
                  name: orderFileName,
                  status: "done",
                  url: "https://pcimageupload.s3.ap-south-1.amazonaws.com/",
                },
              ]
            : [],
        );
      } else {
        form.resetFields();
        Settapshilsfile([]);
      }
    },
    [props.editPreventiveInformationData],
  );

  const getDateFormatYear = (value) => {
    if (value) {
      return moment(value).format("YYYY");
    }
  };

  const onFinish = (values) => {
    if (
      props.editPreventiveInformationData &&
      props.editPreventiveInformationData.length
    ) {
      const accusedRecords = Array.isArray(tapshilsfile)
        ? tapshilsfile.map((item) => item.name)
        : [];
      let obj = {
        ...values,
        chaptorCaseYear: values.chaptorCaseYear
          ? moment(values.chaptorCaseYear).format("YYYY")
          : null,
        tadipar_unit: tadipar && tadipar.toString(),
        orderFIle: accusedRecords[0],
        date_issue_bond: moment(values.date_issue_bond).format("YYYY-MM-DD"),
        proposal_sent_date: moment(values.proposal_sent_date).format(
          "YYYY-MM-DD",
        ),
        action_taken_police_station:
          props.role === "2"
            ? selectDistricts
            : values.action_taken_police_station,
        orderType: values.orderType ? values.orderType : "",
        penalty_amount:
          values.type === "final_bond" ? values.penalty_amount || null : null,
      };
      if (props.role === "4") {
        setSelectDistricts(values.action_taken_police_station);
      }
      props.preventiveInformationUpdate(obj);
    } else {
      const accusedRecords = Array.isArray(tapshilsfile)
        ? tapshilsfile.map((item) => item.name)
        : [];
      let obj = {
        ...values,
        tadipar_unit: tadipar && tadipar.toString(),
        orderFIle: accusedRecords[0],
        date_issue_bond: moment(values.date_issue_bond).format("YYYY-MM-DD"),
        proposal_sent_date: moment(values.proposal_sent_date).format(
          "YYYY-MM-DD",
        ),
        action_taken_police_station:
          props.role === "2"
            ? selectDistricts
            : values.action_taken_police_station,
        penalty_amount:
          values.type === "final_bond" ? values.penalty_amount || null : null,
      };
      setSelectDistricts(values.action_taken_police_station);

      props.preventiveInformationFinish(obj);
    }
  };

  useImperativeHandle(ref, () => ({
    async onFinish() {
      try {
        const values = await form.validateFields(); // validate first
        const accusedRecords = Array.isArray(tapshilsfile)
          ? tapshilsfile.map((item) => item.name).filter(Boolean) // remove empty/null
          : [];

        const fileName =
          accusedRecords.length > 0
            ? accusedRecords[accusedRecords.length - 1]
            : "";
        values.orderFIle = fileName;
        values.penalty_amount =
          values.type === "final_bond" ? values.penalty_amount || null : null;
        return values; // send back to parent if valid
      } catch {
        return null; // invalid -> return null
      }
    },
    resetForm() {
      form.resetFields(); // clears all values
    },
  }));
  console.log("accusedRecords", tapshilsfile);
  const onTadiparChange = (value) => {
    seTadipar(value);
  };

  // function beforePdfUpload(file) {
  //   const isJpgOrPng = file.type === "application/pdf";
  //   if (!isJpgOrPng) {
  //     message.error("Please upload only PDF file!");
  //   }
  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isLt2M) {
  //     message.error("PDF size larger than 2MB!");
  //   }
  //   return isJpgOrPng && isLt2M;
  // }

  function beforePdfUpload(file) {
    return new Promise((resolve, reject) => {
      const isPdfType = file.type === "application/pdf";

      if (!isPdfType) {
        message.error("Please upload only PDF file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("PDF size larger than 2MB!");
        return reject(false);
      }

      // ✅ Correct Magic number validation for PDF
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";

        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isPDF = header === "25504446";

        if (!isPDF) {
          message.error("Invalid PDF file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }
  const tapshilsfilUploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    setProgress(0);
    const config = {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
      },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("document", file, file.name);
    try {
      const res = await axios.post(
        baseUrl + "/document/documentUpload",
        fmData,
        config,
      );

      if (res.data && res.data.error) {
        onError({ ...res.data.error });
      } else {
        Settapshilsfile([
          ...tapshilsfile,
          {
            uid: "1",
            name: res.data.imageName,
            status: "done",
            url: "https://pcimageupload.s3.ap-south-1.amazonaws.com/",
          },
        ]);
        onSuccess("Ok");
      }
    } catch (err) {
      const error = new Error("Some error");
      onError({ err });
    }
  };

  const handleRemoveAccusedRecords = (file) => {
    let temp = tapshilsfile;
    let tempIndex = _.findIndex(tapshilsfile, file);
    temp && temp.length && temp.splice(tempIndex, 1);
    Settapshilsfile([...temp]);
  };
  const handlePreviewAccusedRecords = (file) => {};

  const onPreventiveChange = (value) => {
    setSelectedPreventiveType(value.id);
    setPreventive(value);
    if (value === 5 || value === 6 || value === 7) {
      settadiparShow(true);
    } else {
      settadiparShow(false);
    }
  };

  const getSelectedName = (id) => {
    const selectedOption = preventiveType.find((item) => item.id === id);
    return selectedOption ? selectedOption.name : ""; // Return name or empty string if not found
  };

  const [bondType, setBondType] = useState("final_bond");
  const [startDate, setStartDate] = useState(false);
  const [issueBondDate, setIssueBondDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);

  const disableDateFrom = (current) => {
    if (!issueBondDate) return true;
    return current.isSameOrBefore(issueBondDate, "day");
  };

  const disableDateTo = (current) => {
    if (!fromDate) return true;
    return current.isBefore(fromDate, "day");
  };

  const onIssueBondChange = (date) => {
    setIssueBondDate(date);

    if (!date) {
      form.setFieldsValue({
        date_from: null,
        date_to: null,
        duration: null,
      });
      return;
    }

    const nextDate = moment(date).add(1, "day");

    setFromDate(nextDate);

    form.setFieldsValue({
      date_from: nextDate,
      date_to: null,
      duration: null,
    });
  };

  const onYearChange = (date, dateString) => {
    setStartDate(true);

    const issueDate = moment()
      .year(dateString)
      .month(moment().month())
      .date(moment().date());

    const nextDate = issueDate.clone().add(1, "day");

    setIssueBondDate(issueDate);
    setFromDate(nextDate);

    form.setFieldsValue({
      date_issue_bond: issueDate,
      date_from: nextDate,
      date_to: null,
      duration: null,
    });
  };

  const onDurationChange = (value) => {
    const from = form.getFieldValue("date_from");
    if (!from) return;

    let toDate;

    switch (value) {
      case "3":
        toDate = moment(from).add(3, "months");
        break;
      case "6":
        toDate = moment(from).add(6, "months");
        break;
      case "9":
        toDate = moment(from).add(9, "months");
        break;
      case "12":
        toDate = moment(from).add(1, "year");
        break;
      default:
        return;
    }

    form.setFieldsValue({ date_to: toDate });
  };

  console.log("preventiveType", preventiveType);
  console.log(
    "props?.editPreventiveInformationData[0].preventive_action",
    preventiveAction,
  );
  console.log(
    "value",
    preventiveType.find((item) => item.id === preventiveAction),
  );

  return (
    <div>
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={{ type: "final_bond" }}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="type"
              label={t("select_type")}
              rules={[{ required: true, message: "Please select type" }]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select type"
                onChange={(value) => {
                  setBondType(value);
                  if (value !== "final_bond") {
                    form.setFieldsValue({ penalty_amount: null });
                  }
                }}
              >
                <Option value="final_bond">{t("final_bond")}</Option>
                <Option value="interim_bond">{t("interim_bond")}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="preventive_action"
              label="प्रतिबंधक कारवाही"
              rules={[
                { required: true, message: "Please select प्रतिबंधक कारवाही" },
              ]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select प्रतिबंधक कारवाही"
                onChange={onPreventiveChange}
                value={
                  selectedPreventiveType
                    ? getSelectedName(selectedPreventiveType)
                    : undefined
                }
              >
                {preventiveActionData &&
                  preventiveActionData.length &&
                  preventiveActionData.map((res, index) => (
                    <Option
                      key={index}
                      value={res.id}
                      defaultValue={preventiveType.find(
                        (item) => item.id === preventiveAction,
                      )}
                    >
                      {res.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            {props.role == "4" && (
              <Form.Item
                name="action_taken_police_station"
                label="कारवाई करणारे पो.स्टे"
              >
                <Select
                  optionFilterProp="children"
                  placeholder="कारवाई करणारे पो.स्टे"
                  onChange={(e) => setSelectDistricts(e)}
                  value={selectDistricts}
                >
                  {districts &&
                    districts.length > 0 &&
                    districts.map((res) => (
                      <Option key={res.id} value={res.DistrictName}>
                        {res.DistrictName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            {props.role == "2" && (
              <Form.Item
                name="action_taken_police_station"
                label="कारवाई करणारे पो.स्टे"
                initialValue={selectDistricts}
              >
                <Input placeholder="कारवाई करणारे पो.स्टे" disabled />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              name="proposal_sent_date"
              label="प्रस्ताव पाठवलेला दिनांक"
              rules={[
                {
                  required: true,
                  message: "Please choose the प्रस्ताव पाठवलेला दिनांक",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                inputReadOnly
                disabledDate={(current) => {
                  // Disable future dates
                  return current && current > moment().endOf("day");
                }}
              />
            </Form.Item>
          </Col>
          {tadiparShow === true && (
            <Col span={6}>
              <Form.Item
                name="tadipar_unit"
                label="तडीपार क्षेत्र"
                rules={[
                  { required: false, message: "Please select तडीपार क्षेत्र" },
                ]}
              >
                <Select
                  placeholder="Please select तडीपार क्षेत्र"
                  onChange={onTadiparChange}
                  mode="multiple"
                >
                  {cities &&
                    cities.length &&
                    cities.map((res, index) => (
                      <Option key={index} value={res.City}>
                        {res.City}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              name="chaptorCase"
              label="चॅप्टर केस नं/फायनल ऑर्डर क्रमांक"
              rules={[
                { required: true, message: "Please enter चॅप्टर केस नं" },
              ]}
            >
              <Input
                placeholder="Please enter चॅप्टर केस नं"
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="chaptorCaseYear"
              label="चॅप्टर केस वर्ष"
              rules={[
                { required: true, message: "Please enter चॅप्टर केस वर्ष" },
              ]}
            >
              <DatePicker
                onChange={onYearChange}
                style={{ width: "100%" }}
                picker={"year"}
                inputReadOnly
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="date_issue_bond"
              label="बंधपत्र घेतल्याचा दिनांक"
              rules={[
                {
                  required: true,
                  message: "Please enter बंधपत्र घेतल्याचा दिनांक",
                },
              ]}
            >
              <DatePicker
                disabled={!startDate}
                style={{ width: "100%" }}
                inputReadOnly
                onChange={onIssueBondChange}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              name="date_from"
              label="कालावधी पासून"
              rules={[{ required: true }]}
            >
              <DatePicker
                disabled={!startDate}
                disabledDate={disableDateFrom}
                style={{ width: "100%" }}
                inputReadOnly
                onChange={(date) => setFromDate(date)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="duration"
              label="कालावधी निवडा"
              rules={[{ required: true }]}
            >
              <Select placeholder="कालावधी निवडा" onChange={onDurationChange}>
                <Select.Option value="3">3 Months</Select.Option>
                <Select.Option value="6">6 Months</Select.Option>
                <Select.Option value="9">9 Months</Select.Option>
                <Select.Option value="12">1 Year or more</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="date_to"
              label="कालावधी पर्यंत"
              rules={[{ required: true }]}
            >
              <DatePicker
                disabled={!fromDate}
                disabledDate={disableDateTo}
                style={{ width: "100%" }}
                inputReadOnly
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="orderType"
              label="आदेश देणारे\हद्दपार प्राधधकरण"
              rules={[{ message: "Please enter आदेश देणारेहद्दपार प्राधधकरण" }]}
            >
              <Input placeholder="Please enter आदेश देणारे\हद्दपार प्राधधकरण" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Form.Item
            noStyle
            shouldUpdate={(prev, curr) => prev.type !== curr.type}
          >
            {({ getFieldValue }) =>
              getFieldValue("type") === "final_bond" ? (
                <Col span={6}>
                  <Form.Item
                    name="penalty_amount"
                    label={t("penalty_amounts")}
                    preserve={false}
                  >
                    <Input
                      type="number"
                      min={0}
                      style={{ width: "100%" }}
                      placeholder="दंडाची रक्कम"
                      onKeyPress={(event) => {
                        if (!/^[0-9]$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onPaste={(event) => {
                        const text = event.clipboardData.getData("text");
                        if (!/^[0-9]+$/.test(text)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              ) : null
            }
          </Form.Item>
          <Col
            span={12}
            style={{
              marginBottom: 24,
              paddingTop: bondType === "final_bond" ? 30 : 0,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Upload
                accept="application/pdf"
                customRequest={tapshilsfilUploadImage}
                fileList={tapshilsfile}
                showUploadList={false}
                onRemove={handleRemoveAccusedRecords}
                onPreview={handlePreviewAccusedRecords}
                beforeUpload={beforePdfUpload}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>अपलोड</Button>
              </Upload>
              <span
                style={{ color: "red", fontSize: "12px", whiteSpace: "nowrap" }}
              >
                (Max. 2MB PDF only)
              </span>
            </div>
            {tapshilsfile.map((file) => (
              <div key={file.uid} style={{ marginTop: 8 }}>
                <Button
                  type="link"
                  size="small"
                  style={{ padding: 0 }}
                  onClick={() => handleRemoveAccusedRecords(file)}
                >
                  {file.name}
                </Button>
              </div>
            ))}
          </Col>
        </Row>
      </Form>
    </div>
  );
});
